"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Stock_1 = require("../model/Stock");

var StockConverter_1 = require("./StockConverter");
/**
 * Implementation of {@link StockConverter}.
 *
 * @author JMe
 */


var StockConverterImpl =
/*#__PURE__*/
function (_StockConverter_1$Sto) {
  _inherits(StockConverterImpl, _StockConverter_1$Sto);

  function StockConverterImpl() {
    _classCallCheck(this, StockConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(StockConverterImpl).apply(this, arguments));
  }

  _createClass(StockConverterImpl, [{
    key: "toDocument",

    /**
     * @inheritDoc
     */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        name: source.name
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new Stock_1.Stock(conversions.documentToClassId(source), conversions.asObject(source, 'externalId', function (v) {
        return v;
      }), conversions.asObject(source, 'name', function (v) {
        return v;
      }));
    }
  }]);

  return StockConverterImpl;
}(StockConverter_1.StockConverter);

exports.StockConverterImpl = StockConverterImpl;